/**
 * orga-app-api - incidents-v1-oa3_1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface IncidentsRolleBerechtigung { 
    funktionsbereich_id: string;
    rolle_id: string;
    darf_verantwortung_bei_anlegen?: boolean;
    darf_delegation_bei_anlegen?: boolean;
    mandant_id?: string;
    modified_on_utc?: Date;
}

